import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import {
  FaBook,
  FaUsers,
  FaInfoCircle,
  FaCalendarAlt,
  FaDumbbell,
  FaShoppingBag
} from 'react-icons/fa';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Home.css';

// Función para importar dinámicamente imágenes WebP
const importAll = (r) => r.keys().map(r);
// Carga todas las imágenes .webp del directorio y toma hasta 11
const allImages = importAll(require.context('../assets/images', false, /\.(webp)$/));
const images = allImages.slice(0, 11);

function Home() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: Math.min(images.length, 3),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: Math.min(images.length, 2) } },
      { breakpoint: 768,  settings: { slidesToShow: Math.min(images.length, 2) } },
      { breakpoint: 480,  settings: { slidesToShow: 1 } },
    ],
  };

  const buttons = [
    { to: '/metodologia', Icon: FaBook,       label: 'Metodología' },
    { to: '/equipo',      Icon: FaUsers,      label: 'Equipo' },
    { to: '/politica-privacidad', Icon: FaInfoCircle, label: 'Información' },
    { to: '/contact',     Icon: FaCalendarAlt,label: 'Contacto' },
    { to: '/services',    Icon: FaDumbbell,   label: 'Servicios' },
    { to: '/tienda',      Icon: FaShoppingBag,label: 'Tienda' },
  ];

  return (
    <div className="home-container">
      {/* Carrusel */}
      <div className="carousel-wrapper">
        <Slider {...settings} className="carousel">
          {images.map((src, i) => (
            <div key={i} className="slide-item">
              <div className="card">
                <img src={src} alt={`Imagen ${i + 1}`} />
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Grid de botones estilo Services */}
      <section className="grid-section">
        <div className="grid">
          {buttons.map(({ to, Icon, label }) => (
            <Link key={to} to={to} className="grid-item">
              <Icon className="service-icon" />
              <span className="service-title">{label}</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
